import React, { Component } from 'react';
import './index.css'
import BsySearchResult from "../BsySearchResult";
import BsyAlert from '../BsyAlert';
import tipAlert from '../../Login/BsyAlertTip/Staticize';

class BsyRecyclePane extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            success: false
        }
    }

    componentDidMount() {
        this.loadRecycleList()
    }

    loadRecycleList = () => {
        React.axios("/dashboard/app/" + window.FX.STATIC.APPID + "/list_recycle", {}).then((res) => {
            this.setState({
                list: res.data,
                success: res.data.length > 0
            })
        })
    }

    _deleteEntry = (a, b, c) => {
        return (event) => {
            const FX = window.FX;
            const $ = window.$;
            let e = this
                , f = "";
            switch (b) {
                case "group":
                    f = React.language("group");
                    break;
                case "form":
                    f = React.language("form");
                    break;
                case "report":
                case "dash":
                    f = React.language("scenes")
                    break;
                default:
            }

            FX.Msg.bubble({
                anchor: $(event.currentTarget),
                // hAdjust:16,
                contentHTML: $('<div style="width: 210px"/>').text(React.language("completely.delete.irreversible", { name: (f + '-' + c.name) })),
                dockPosition: "left",
                type: "error",
                text4Ok: React.language("delete"),
                onClose: function () {
                    return !1;
                },
                onOk: function (c1) {
                    switch (b) {
                        case "form":
                        case "report":
                        case "dash":
                        case "scenes":
                            e.removeEntry(a, null, document.getElementById("recycle" + a));
                            break;
                        default:
                    }
                }
            })
        }
    }

    removeEntry = (a, cb, e) => {
        const $ = window.$;
        const FX = window.FX;
        let b = this;
        FX.Utils.ajax({
            url: "/dashboard/app/" + FX.STATIC.APPID + "/entry/" + a + "/remove"
        }, function (c, d) {
            if (cb)
                cb("success");
            else {
                tipAlert({
                    type: "success",
                    msg: React.language("delete.success")
                })
                b.loadRecycleList()
            }
            // cb && cb("success");
        }, function (a, b) {
            var c = a.responseJSON || {};
            tipAlert({
                type: "error",
                msg: c.msg || React.language("delete.fail")
            })
            cb && cb("error");
        })
    }

    clearAll = () => {
        const FX = window.FX;
        let _this = this;

        let ids = _this.state.list;
        let count = ids.length;

        if (count <= 0) {
            return
        }


        BsyAlert({
            title: React.language("empty.recycle.forms"),
            msg: React.language('empty.recycle.irreversible'),
            type: "warning",
            text4Ok: '清空',
            text4Cancel: React.language("cancel"),
            OkType: "blue",
            ok: (value) => {


                let t1 = FX.Utils.createLoadLayer("body", {
                    isLight: !0,
                    hasLoader: !0,
                    text: React.language("emptying.recycle.forms", {
                        count1: count,
                        count2: count,
                    })
                });

                setTimeout(function () {
                    var index = 0;
                    //失败的个数
                    var faildIndex = 0;
                    var id = ids[index].entryId;
                    index++;
                    var cb = function (type) {
                        if (count - index === 0) {
                            t1.find(".x-loader-text").text(React.language("emptying.recycle.forms", {
                                count1: (count - index),
                                count2: count,
                            }));
                            setTimeout(function () {
                                t1.remove();
                                if (faildIndex === 0) {
                                    tipAlert({
                                        type: "success",
                                        msg: React.language("recycle.has.cleaned")
                                    })
                                }
                                else {
                                    tipAlert({
                                        type: "success",
                                        msg: React.language("clean.tip", {
                                            cf: (count - faildIndex),
                                            fi: faildIndex
                                        })
                                    })
                                }
                            }, 500)
                            _this.loadRecycleList()
                            return;
                        }


                        if (type !== "success") {
                            faildIndex++;
                        }

                        t1.find(".x-loader-text").text(React.language("emptying.recycle.forms", {
                            count1: (count - index),
                            count2: count,
                        }));
                        var id = ids[index].entryId;

                        setTimeout(function () {
                            _this.removeEntry(id, cb, document.getElementById("recycle" + id))
                        }, 200)

                        index++;
                    };
                    _this.removeEntry(id, cb, document.getElementById("recycle" + id))
                }, 200)


                return true;
            }
        })


    }

    restoreEntry = (id, val) => {
        return () => {
            this.props.restoreEntry && this.props.restoreEntry(id, val, () => {
                this.loadRecycleList()
            });
        }
    }



    render() {
        const { list, success } = this.state
        return (
            <div className="BsyRecyclePane">
                <div className="pane-top">
                    <BsySearchResult
                        items={list}
                        width={320}
                        height={350}
                        dockPosition="left"
                        onCreatResult={(res) => {
                            return res.length > 0 ? <ul className="search-recycle">
                                {
                                    res.map((val) => {
                                        return val && <li key={val.id}>
                                            {
                                                <div className="menu-item" title={val.text}>
                                                    <div className="item">
                                                        <i className={`node-icon icon-bsy-${val.type}${!val.hasCoop ? "-flow" : ""} ${val.icon <= 24 ? `icon-bsy-form-'${val.icon}` : `icon-new-bsy-form-'${val.icon}`}`} />
                                                        <span dangerouslySetInnerHTML={{ __html: val.titleHtml }} />
                                                    </div>
                                                    <div className="edit">
                                                        <span className="recover" onClick={this.restoreEntry(val.entryId, val)}>{React.language('recover')}</span>
                                                        <span className="delete" onClick={this._deleteEntry(val.entryId, val.type, val)}>{React.language('delete')}</span>
                                                    </div>
                                                </div>
                                            }
                                        </li>
                                    })
                                }
                            </ul> : <div className="emptySearch">
                                {React.language('field.location.empty')}
                            </div>
                        }}
                    />
                    <div className="clearAll" onClick={this.clearAll}>
                        <i className="icon-remove-bold" />
                        <span>{React.language('empty.recycle.forms')}</span>
                    </div>
                </div>
                <div className="pane-cont">
                    {success && <div className="recycleList">
                        <ul>
                            {
                                list.map((val) => {
                                    return <li className={"item-pane"} key={val.entryId} data-id={val.entryId}>
                                        {
                                            <div className="menu-item" id={"recycle" + val.entryId} title={val.name}>
                                                <div className="item">
                                                    <i className={`node-icon icon-bsy-${val.type}${!val.hasCoop ? "-flow" : ""} ${val.icon <= 24 ? `icon-bsy-form-'${val.icon}` : `icon-new-bsy-form-${val.icon}`}`} />
                                                    <span>{val.name}</span>
                                                </div>
                                                <div className="edit">
                                                    <span className="recover"
                                                        onClick={this.restoreEntry(val.entryId, val)}>{React.language('recover')}</span>
                                                    <span className="delete"
                                                        onClick={this._deleteEntry(val.entryId, val.type, val)}>{React.language('delete')}</span>
                                                </div>
                                            </div>
                                        }
                                    </li>
                                })
                            }
                        </ul>
                    </div>}
                </div>
            </div>
        );
    }
}

export default BsyRecyclePane;